<script lang="ts">
  import SLAKRoutes from "../SLAKRoutes";
  import ClassicNavItem from "./ClassicNavItem.svelte";

  const navRoutes = SLAKRoutes.filter((r) => r.kind.includes("+navbar"));
</script>

<map name="banner-map">
  <area
    target=""
    alt="SLAK Gaming"
    title="SLAK Gaming"
    href="/"
    coords="342,96,14,18"
    shape="rect"
  />
</map>

<div class="header-container">
  <header class="banner-with-nav">
    <img
      src="assets/classic/header_top.jpg"
      alt="main decorative banner"
      usemap="#banner-map"
    />
    <nav class="banner-nav">
      <img
        src="assets/classic/header_bottom.jpg"
        alt="part of decorative banner"
      />
      {#each navRoutes as route, i}<ClassicNavItem
          {route}
        />{#if navRoutes.length > i + 1}<img
            class="divider"
            alt="nav item separator"
            src="assets/classic/nav_separator.gif"
          />{/if}
      {/each}
    </nav>
  </header>
</div>

<div class="header-container-mobile">
  <div class="banner">
    <img
      src="assets/classic/header_mobile.png"
      alt="main decorative banner"
      usemap="#banner-map"
    />
  </div>
  <nav>
    {#each navRoutes as route, i}<ClassicNavItem
        {route}
      />{#if navRoutes.length > i + 1}<img
          class="divider"
          alt="nav item separator"
          src="assets/classic/nav_separator.gif"
        />{/if}
    {/each}
  </nav>
</div>

<style lang="scss">
  .header-container {
    margin-top: 1rem;
    text-align: center;

    & > .banner-with-nav {
      display: inline-block;

      & > * {
        text-align: initial;
        display: block;
      }
    }
  }

  .header-container-mobile {
    display: none;

    margin-top: 1rem;
    text-align: center;

    .banner {
      border-radius: 9px;
      border-color: #d0d0d0;
      border-width: 4px;
      border-style: ridge;

      overflow: hidden;
      height: 95px;
    }
  }

  @media screen and (max-width: 860px) {
    .header-container {
      display: none;
    }
    .header-container-mobile {
      display: block;
    }
  }
</style>
